const SEO = [
	{
		page: "home",
		description:
			"I am a full stack web developer in erie pa. Let's create a new project together",
		keywords: ["Cramer", "Matthew Cramer", "Erie Multimedia"],
	},

	{
		page: "about",
		description:
			"I have over 20 years experience as a web developer.",
		keywords: ["Cramer", "Matthew Cramer", "Erie Multimedia"],
	},

	{
		page: "articles",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
		keywords: ["Cramer", "Matthew Cramer", "Erie Multimedia"],
	},

	{
		page: "projects",
		description:
			"I've worked on many projects over the years, here are just a few",
		keywords: ["Cramer", "Matthew Cramer", "Erie Multimedia"],
	},

	{
		page: "contact",
		description:
			"If you're interested in collaborating on a project, feel free to reach out to me. I'm always open to new ideas and opportunities.",
		keywords: ["Cramer", "Matthew Cramer", "Erie Multimedia"],
	},
];

export default SEO;
